module.exports = __webpack_public_path__ + "static/media/image_53.d3834282.png";